import { fetchPosts } from 'wordpress/actions'
import { withWordpressLanguage } from 'wordpress/utils'

import { promotedOfferSelector, promotedOfferIdSelector, promotionsRibbonSelector } from './selectors'
import './styles.scss'

class SpecialOffers extends Component {
    componentDidMount() {
        const { fetchPosts, promotedOfferId } = this.props

        fetchPosts('promotions', [promotedOfferId])
    }

    render() {
        const {
            promotionsRibbon: { enabled, linkAction, page, url },
            promotedOffer,
        } = this.props

        if (!enabled || !promotedOffer) return null

        const { title, shortDescription } = promotedOffer
        const shortDescriptionHTML = { __html: shortDescription }
        const getLink = children => {
            const props = {
                ...(linkAction === 'page' ? { to: page } : { href: url }),
            }

            return linkAction === 'page' ? (
                <Link {...props}>{children}</Link>
            ) : (
                <a target="__blank" {...props}>
                    {children}
                </a>
            )
        }

        return getLink(
            <div className="special-offer">
                <div className="title">
                    <h2>{title}</h2>
                </div>
                <div className="body">
                    <h2 dangerouslySetInnerHTML={shortDescriptionHTML} />
                </div>
            </div>
        )
    }
}

const actions = { fetchPosts }

export default compose(
    withWordpressLanguage,
    connect(
        createStructuredSelector({
            promotedOfferId: promotedOfferIdSelector,
            promotedOffer: promotedOfferSelector,
            promotionsRibbon: promotionsRibbonSelector,
        }),
        actions
    )
)(SpecialOffers)
